export const FSM_SETTINGS_MEAL_BREAK_GET = "FSM_SETTINGS_MEAL_BREAK_GET";
export const FSM_SETTINGS_MEAL_BREAK_GET_RESPONSE = "FSM_SETTINGS_MEAL_BREAK_GET_RESPONSE";
export const FSM_SETTINGS_MEAL_BREAK_CREATE = "FSM_SETTINGS_MEAL_BREAK_CREATE";
export const FSM_SETTINGS_MEAL_BREAK_CREATE_RESPONSE = "FSM_SETTINGS_MEAL_BREAK_CREATE_RESPONSE";

